import type { ReactNode } from "react";

/** Piezas comunes de los formularios oficiales impresos (033 y 024): casillas y cajas con rótulo, como en el papel. */

/** Casilla cuadrada: con una X si está marcada. */
export function Casilla({ marcada, etiqueta }: { marcada?: boolean; etiqueta?: string }) {
  return <span className={`of-cas${marcada ? " x" : ""}`} role="img" aria-label={`${etiqueta ?? "Casilla"}: ${marcada ? "marcada" : "sin marcar"}`}>{marcada ? "X" : ""}</span>;
}

/** Casilla con su rótulo al lado: «☒ Diabetes». */
export function ConCasilla({ marcada, children }: { marcada?: boolean; children: ReactNode }) {
  return <span className="of-con-cas"><Casilla marcada={marcada} etiqueta={typeof children === "string" ? children : undefined} /> {children}</span>;
}

/** Caja con rótulo pequeño arriba y el valor abajo. */
export function Caja({ k, children, ancho }: { k: string; children?: ReactNode; ancho?: number }) {
  return <div className="of-caja" style={ancho ? { gridColumn: `span ${ancho}` } : undefined}><span>{k}</span><b>{children}</b></div>;
}

/** Barra de título de una sección del formulario. */
export function Seccion033({ letra, titulo, children }: { letra: string; titulo: string; children: ReactNode }) {
  return (
    <section className="of-sec">
      <h2><i>{letra}</i> {titulo}</h2>
      {children}
    </section>
  );
}

/** Líneas en blanco para completar a mano. */
export const Lineas = ({ n }: { n: number }) => <>{Array.from({ length: n }, (_, i) => <div key={i} className="of-linea" />)}</>;
